import { Layout, Details, TextBlock, NoteText, TerminatedBlock } from './ui';

const Certificate = {
  Layout,
  Details,
  TextBlock,
  NoteText,
  TerminatedBlock,
};

export { Certificate };
export * from './model';
